<template><div></div></template>
<script>
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$router.replace(from.path);
      // 跳到該路由頁面後，再替換為from.path來源路徑
    });
  },
};
</script>
